export default __webpack_public_path__ + "react/assets/svg/info-graphic.svg";